import { useRouter as useNextRouter } from "next/router";
import type React from "react";
import { useEffect, useState } from "react";
import { Menu as MenuIcon } from "@tamagui/lucide-icons";
import { Button, type YStackProps } from "@medbillai/ui";
import { AdaptiveDialogSheet } from "../../../components/AdaptiveDialogSheet";
export type MobileNavPopoverProps = {
  children: React.ReactNode;
  // Padding for the content wrapper.
  contentPadding?: YStackProps["padding"];
};
export const MobileNavPopover = ({
  children,
  contentPadding
}: MobileNavPopoverProps) => {
  const [open, setOpen] = useState(false);
  const router = useNextRouter();
  useEffect(() => {
    const handleRouteChange = () => {
      setOpen(false);
    };
    router.events.on("routeChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router.events]);
  return <>
      <Button variant="tertiary" size="medium" icon={MenuIcon} aria-label="Open menu" aria-expanded={open} onPress={() => setOpen(!open)} data-sentry-element="Button" data-sentry-source-file="MobileNavPopover.web.tsx" />

      <AdaptiveDialogSheet open={open} onOpenChange={setOpen} title="Menu" hideTitle hideClose absolutePositionTitle snapPointsMode="fit" contentWrapperProps={{
      padding: contentPadding ?? 0
    }} data-sentry-element="AdaptiveDialogSheet" data-sentry-source-file="MobileNavPopover.web.tsx">
        {children}
      </AdaptiveDialogSheet>
    </>;
};